import $api from '../services';

export default {
    addLike(sessionId) {
        return $api.post(`likes/${sessionId}`);
    },
    removeLike(sessionId) {
        return $api.delete(`likes/${sessionId}`);
    }
};
